module.exports = __webpack_public_path__ + "images/home_pic_banner-00e4c0a70e.png";